import React, { useEffect, useState } from "react";
import Breakpoint, {
  BreakpointProvider,
  setDefaultBreakpoints,
} from "react-socks";
import { header } from "react-bootstrap";
import { Link } from "@reach/router";
import useOnclickOutside from "react-cool-onclickoutside";

setDefaultBreakpoints([{ xs: 0 }, { l: 1199 }, { xl: 1200 }]);

const NavLink = (props) => (
  <Link
    {...props}
    getProps={({ isCurrent }) => {
      return {
        className: isCurrent ? "active" : "non-active",
      };
    }}
  />
);

export default function () {
  const [openMenu1, setOpenMenu1] = React.useState(false);

  // Removed openMenu (Home) state and handlers
  const handleBtnClick1 = () => setOpenMenu1(!openMenu1);
  const closeMenu1 = () => setOpenMenu1(false);

  const ref1 = useOnclickOutside(() => {
    closeMenu1();
  });

  const [showmenu, btn_icon] = useState(false);

  useEffect(() => {
    const header = document.getElementById("myHeader");
    const totop = document.getElementById("scroll-to-top");
    const sticky = header.offsetTop;
    const scrollCallBack = window.addEventListener("scroll", () => {
      btn_icon(false);
      if (window.pageYOffset > sticky + 300) {
        header.classList.add("sticky");
        totop.classList.add("show");
      } else {
        header.classList.remove("sticky");
        totop.classList.remove("show");
      }
    });
    return () => {
      window.removeEventListener("scroll", scrollCallBack);
    };
  }, []);

  return (
    <header id="myHeader" className="navbar">
      <div className="container-fluid">
        <div className="row m-2-hor w-100-nav">
          <div className="logo">
            <div className="navbar-title navbar-item">
              <NavLink to="/">
                <img
                  src="./img/WitalyGroupLogo.png"
                  className="img-fluid"
                  style={{ width: "250px", height: "auto" }}
                  alt="#"
                />
              </NavLink>
            </div>
          </div>

          <BreakpointProvider>
            <Breakpoint l down>
              {showmenu && (
                <div className="menu">
                  {/* HOME UPDATED HERE */}
                  <div className="navbar-item">
                    <NavLink to="/" onClick={() => btn_icon(!showmenu)}>
                      Home
                    </NavLink>
                  </div>

                  <div className="navbar-item">
                    <NavLink
                      to="/witaly-interior"
                      onClick={() => btn_icon(!showmenu)}
                    >
                      Witaly Interior
                    </NavLink>
                  </div>
                  <div className="navbar-item">
                    <a
                      href="https://www.biowitaly.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => btn_icon(!showmenu)}
                    >
                      Bio Witaly
                    </a>
                  </div>
                  <div className="navbar-item">
                    <a
                      href="https://www.lavilla.co.ke/"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => btn_icon(!showmenu)}
                    >
                      Witaly Hospitality
                    </a>
                  </div>
                  <div className="navbar-item">
                    <NavLink
                      to="/witaly-shipping"
                      onClick={() => btn_icon(!showmenu)}
                    >
                      Witaly Shipping
                    </NavLink>
                  </div>
                  

                  
                  <div className="navbar-item">
                    <NavLink to="/contact" onClick={() => btn_icon(!showmenu)}>
                      Contact
                    </NavLink>
                  </div>
                </div>
              )}
            </Breakpoint>

            <Breakpoint xl>
              <div className="menu">
                {/* HOME UPDATED HERE */}
                <div className="navbar-item">
                  <NavLink to="/">Home</NavLink>
                </div>

                <div className="navbar-item">
                  <NavLink to="/witaly-interior">Witaly Interior</NavLink>
                </div>

                <div className="navbar-item">
                  <a
                    href="https://www.biowitaly.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bio Witaly
                  </a>
                </div>

                 <div className="navbar-item">
                  <a
                    href="https://www.lavilla.co.ke/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Witaly Hospitality
                  </a>
                </div>

                <div className="navbar-item">
                  <NavLink to="/witaly-shipping">Witaly Shipping</NavLink>
                </div>
                 
                <div className="navbar-item">
                  <NavLink to="/contact">Contact</NavLink>
                </div>
              </div>
            </Breakpoint>
          </BreakpointProvider>
        </div>

        <button className="nav-icon" onClick={() => btn_icon(!showmenu)}>
          <div className="menu-line white"></div>
          <div className="menu-line1 white"></div>
          <div className="menu-line2 white"></div>
        </button>
      </div>
    </header>
  );
}
